<template>
  <div class="registration" v-loading="loading">
    <childTitle class="titleData" :titleData="titleData"></childTitle>
    <div class="layout-page-box">
      <el-form :inline="true" label-width="100px" label-position="right" class="search-form">

        <el-form-item label="类别">
          <el-select v-model="filters.category" clearable="" placeholder="选择类别">
            <el-option v-for="(item,index) in options" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="院区">
          <el-select v-model="filters.areaName" placeholder="请选择院区" style="width:90%">
            <el-option v-for="item in areaOptions" :key="item.value" :label="item.menuName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="客户姓名">
          <div class="no">
            <el-select @blur.capture.native="onBlur('clientName')" @change.capture.native="onInput($event,'clientName')" :popper-append-to-body="false" clearable v-model="filters.clientName" placeholder="请输入客户姓名" multiple allow-create filterable default-first-option></el-select>
          </div>
        </el-form-item>
        <el-form-item label="手机号">
          <div class="no">
            <el-select @blur.capture.native="onBlur('clientMobile')" @change.capture.native="onInput($event,'clientMobile')" :popper-append-to-body="false" clearable v-model="filters.clientMobile" placeholder="请输入手机号" multiple allow-create filterable default-first-option></el-select>
          </div>
        </el-form-item>
        <el-form-item label="医生">
          <el-select v-model="filters.doctorName" placeholder="请选择医生" multiple filterable remote clearable @focus="focus(1)" :filter-method="doctorMatch">
            <el-option v-for="item in newList1" :key="item.id" :label="item.menuName" :value="item.menuName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="卡号">
          <div class="no">
            <el-select @blur.capture.native="onBlur('clientCard')" @change.capture.native="onInput($event,'clientCard')" :popper-append-to-body="false" clearable v-model="filters.clientCard" placeholder="请输入卡号" multiple allow-create filterable default-first-option></el-select>
          </div>
        </el-form-item>
        <el-form-item label="护士">
          <el-select v-model="filters.nurseName" placeholder="请选择护士" multiple filterable remote clearable @focus="focus(2)" :filter-method="nurseMatch">
            <el-option v-for="item in newList2" :key="item.id" :label="item.menuName" :value="item.menuName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="注射产品">
          <el-select v-model="filters.injectionProductId" placeholder="请选择注射产品" multiple filterable remote clearable @focus="focus(3)" :filter-method="productionMatch">
            <el-option v-for="item in newList3" :key="item.id" :label="item.menuName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期">
          <el-date-picker v-model="filters.startTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search" size="small">查询</el-button>
        </el-form-item>
      </el-form>
      <div class=" buttonText">
        <!-- <div class="addData" @click="add">新增注射微整科登记表</div>
        <div class="addData" @click="del" v-if="keyId==1">删除</div>
        <div class="delete" @click="exportData">导出注射微整科耗材表</div> -->
        <el-button type="warning" @click="add" icon="el-icon-plus">新增注射微整科登记表</el-button>
        <el-button type="danger" @click="del" icon="el-icon-delete" v-if="keyId==1">删除</el-button>
        <el-button type="success" @click="exportData" icon="el-icon-check">导出注射微整科耗材表</el-button>
      </div>
    </div>
    <div class="layout-page-box">
      <el-table v-horizontal-scroll="'always'" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" :height="tableHeight" :header-cell-style="{color:'#626365'}" :row-class-name="tableRowClassName">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="examine" label="是否审核" width="80" fixed>
          <template slot-scope="scope">
            <el-switch v-model="scope.row.examine" active-color="#13ce66" inactive-color="#C9C9C9" @change="change(scope.$index, scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="place" label="场地"></el-table-column>
        <el-table-column prop="time" label="日期" width="100"></el-table-column>
        <el-table-column prop="clientCard" label="客户卡号" width="120"></el-table-column>
        <el-table-column prop="clientName" label="客户姓名"></el-table-column>
        <!-- <el-table-column prop="injectionProductName" label="注射产品" width="180"></el-table-column> -->
        <el-table-column prop="injectionProductName" label="注射产品" width="180">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.productList" :key="index">
              <span class="sp">{{item.injectionProductName}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="operationName" label="手术名称" width="150"><template slot-scope="scope">{{scope.row.operationName.replaceAll('null', '无')}}</template></el-table-column>
        <el-table-column prop="operationTime" label="手术时间"></el-table-column>
        <el-table-column prop="matchingNurse" label="配台护士"></el-table-column>
        <el-table-column prop="nurseName" label="护士姓名"></el-table-column>
        <el-table-column prop="doctorName" label="医生姓名"></el-table-column>
        <el-table-column prop="skinProductName" label="手术材料" width="180">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.productList" :key="index">
              <span class="sp">{{item.productName}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="specification" label="规格(注射总量)">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.productList" :key="index">
              <span class="sp">{{item.specification}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="number" label="数量">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.productList" :key="index">
              <span class="sp">{{item.number}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="operationAmt" label="金额"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column prop="remarks" label="附加备注"></el-table-column>
        <el-table-column prop="category" label="类别"></el-table-column>
        <el-table-column align="center" label="操作" width="150">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)" :disabled="scope.row.timeIdentification == true?true:false">编辑</el-button>
            <el-button size="mini" type="warning" @click="handleLog(scope.$index, scope.row)" :disabled="scope.row.identification == 0?true:false">日志</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
      </el-pagination>
    </div>
    <!-- 新增注射微整科耗材表弹框 -->
    <addSkin v-if="dialogForm" ref="addSkin" :code="code" :childData="childData" @add-comment="appendComment"></addSkin>
    <!-- 查看日志弹窗 -->
    <el-dialog title="日志" :visible.sync="dialogTableVisible">
      <el-table :data="gridData">
        <el-table-column prop="createBy" label="操作人" width="150"></el-table-column>
        <el-table-column prop="updateTime" label="操作时间" width="200"></el-table-column>
        <el-table-column prop="operateType" label="操作类型"></el-table-column>
        <el-table-column prop="operateDetails" label="操作内容"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import addSkin from "./addSkin.vue";
import { mapState, mapGetters } from 'vuex'
import childTitle from './title.vue';
export default {
  components: {
    // 新增弹框
    addSkin,
    childTitle,
  },
  name: 'consumables',
  computed: {
    // ...mapState(['placeList']),
    ...mapGetters(['skinDoctorList', 'skinNurseList', 'skinList']),
  },
  data() {
    return {
      disabled: false,
      gridData: [],
      dialogTableVisible: false,
      filters: {
        types: '',
        pagination: {
          page: 1,
          limit: 10,
          total: 0
        },
        startTime: [_g.getMonths()[0], _g.getMonths()[1]],
        endTime: '',
      },
      options: [{
        label: '全部 ',
        value: '内外'
      }, {
        label: '内',
        value: '内'
      }, {
        label: '外',
        value: '外'
      },],
      tableData: [],
      dialogForm: false,
      loading: false,
      code: '',
      childData: {},
      empId: Lockr.get("skinEmpId"),
      jurisdictionId: Lockr.get("skinJurisdictionId"),
      keyId: Lockr.get("skinJurisdictionId").replace(/,/g, ""),
      areaOptions: [
        {
          id: '全部',
          menuName: '全部'
        }, {
          id: '伯思立',
          menuName: '伯思立'
        }, {
          id: '百达丽',
          menuName: '百达丽'
        }, {
          id: '翡立思',
          menuName: '翡立思'
        }
      ],
      tableHeight: '',
      inputclientName: '',
      inputmobile: '',
      inputCard: '',
      newList1: [],
      newList2: [],
      newList3: [],
      userName: Lockr.get("skinUserName"),
      injectionProductName: [],
      titleData: {
        musProjectOld: 0,
        projectAmtOld: 0,
        musAmt: 0,
        musAmtOld: 0,
        musProject: 0,
        client: 0,
        clientOld: 0,
        projectAmt: 0,
        project: 0,
        projectOld: 0,
        musClient: 0,
        musClientOld: 0,
        musTime: 0,
        purchaseTime: 0,
        aa: 0,
        bb: 0,
      },
    }
  },
  methods: {
    search() {
      this.filters.pagination.page = 1
      this.refresh()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    pageChanged(page) {
      this.filters.pagination.page = page
      this.refresh()
    },
    handleSizeChange(sizes) {
      this.filters.pagination.limit = sizes
      this.refresh()
    },
    refresh() {
      router.push({
        path: this.$route.path,
        query: _.merge({}, this.$route.query, {
          __query: JSON.stringify(this.pagination)
        }, {
            random: Math.random()
          })
      })
    },
    // 新增注射科登记表
    add() {
      this.dialogForm = true;
      this.$nextTick(() => {
        this.code = 0
        this.childData = {
          clientMobile: '',
          clientCard: '',
          clientName: '',
          serviceName: '',
          clientSex: "",
          clientAge: '',
          time: '',
          category: '',
          dsepartmentName: '注射微整科',
          areaName: '',
          operationMaterials: [
            {
              doctorName: "",
              nurseName: '',
              injectionProductList: [
                {
                  productName: '',
                  specification: '',
                  number: '',
                  money: '',
                  injectionPart: [],
                  productList: [
                    {
                      productName: '',
                      specification: '',
                      number: '',
                      money: '',

                    }
                  ],
                }
              ],
            }
          ],
          registerInformationDtoList: [
            {
              diagnosis: '',
              injectionPart: '',
              partDoctor: "",
              dutyNurse: '',
              anesthetistName: "",
              anesthesiaMode: "",
              productRemark: '',
            }
          ],
          therapeuticIndexList: [
            // {
            //   operationName: "",
            //   operationNameNo: '',
            //   menuName: "",
            //   therapeuticType: '',
            //   operationIndex: '',
            //   therapeuticIndex: '',
            // }
          ],
        },
          this.$refs.addSkin.openDialog1Visible();
        this.$refs.addSkin.openLoading();
      });
    },
    // 表格不同行设置不同的样式
    tableRowClassName({
      row,
      rowIndex
    }) {
      if (row.identification == 1) {
        return 'warningRed';
      }
    },
    // 查询
    query(page) {
      this.loading = true
      this.newList3.forEach(ele => {
        this.filters.injectionProductId.forEach(item => {
          if (item == ele.id) {
            this.injectionProductName.push(ele.menuName)
          }
        });
      });
      let querys = {
        startTime: "",
        endTime: "",
        page: page,
        size: this.filters.pagination.limit,
        category: this.filters.category,
        jurisdictionId: this.jurisdictionId,
        jurisdictionName: Lockr.get("skinJurisdictionName"),
        createBy: this.empId,
        areaName: this.filters.areaName,
        clientName: this.filters.clientName.toString(),
        clientMobile: this.filters.clientMobile.toString(),
        clientCard: this.filters.clientCard.toString(),
        doctorName: this.filters.doctorName.toString(),
        nurseName: this.filters.nurseName.toString(),
        // anesthesiaMode: this.filters.anesthesiaMode.toString(),
        injectionProductName: this.injectionProductName.toString(),
        injectionProductId: this.filters.injectionProductId.toString(),
      }
      if (this.filters.startTime) {
        querys.startTime = this.filters.startTime[0]
        querys.endTime = this.filters.startTime[1]
      }
      api.request("/register/findDermatologyMaterialsPage", querys, (res) => {
        // console.log(res)
        var data = res.data.list;
        this.tableData = data
        this.tableData.forEach(ele => {
          ele.place = '注射室'
          ele.operationTime = '/'

        });
        this.filters.pagination.total = parseInt(res.data.count);
        this.loading = false

        api.request('/register/findDermatologyStatistic', querys, (res) => {
          if (res.data.length) {
            console.log('0000');
            this.titleData = res.data[0]
            this.titleData.aa = (this.titleData.projectAmt + this.titleData.projectAmtOld).toFixed(2)
            // this.titleData.bb = (this.titleData.projectAmt + this.titleData.projectAmtOld).toFixed(2)
          } else if (!res.data.length) {
            console.log('999');
            this.titleData = res.data
            this.titleData.aa = (this.titleData.projectAmt + this.titleData.projectAmtOld).toFixed(2)
          }
        })
      });
    },

    // 导出注射微整科耗材表数据
    exportData() {
      let exportUrl = axios.defaults.baseURL;
      this.newList3.forEach(ele => {
        this.filters.injectionProductId.forEach(item => {
          if (item == ele.id) {
            this.injectionProductName.push(ele.menuName)
          }
        });
      });
      var register = {
        total: this.filters.pagination.total,
        category: this.filters.category,
        areaName: this.filters.areaName,
        clientName: this.filters.clientName.toString(),
        clientMobile: this.filters.clientMobile.toString(),
        clientCard: this.filters.clientCard.toString(),
        doctorName: this.filters.doctorName.toString(),
        nurseName: this.filters.nurseName.toString(),
        // anesthesiaMode: this.filters.anesthesiaMode.toString(),
        injectionProductName: this.injectionProductName.toString(),
        injectionProductId: this.filters.injectionProductId.toString(),
        userName: this.userName

      }
      if (this.filters.startTime) {
        register.startTime = this.filters.startTime[0]
        register.endTime = this.filters.startTime[1]
      }
      var formData = new FormData();
      formData.append("register", JSON.stringify(register))
      this.$confirm("此操作将导出excel文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          axios
            .post(
              exportUrl + "register/excelDermatologyRegister", formData, {
                responseType: "blob",
              }
            )
            .then((res) => {
              console.log(res)
              const blob = new Blob([res.data], {
                type: "application/vnd.ms-excel",
              });
              // console.log(blob, '----------0990');
              const fileName = "注射微整科耗材表数据.xlsx";
              const linkNode = document.createElement("a");
              linkNode.download = fileName; //a标签的download属性规定下载文件的名称
              linkNode.style.display = "none";
              linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
              document.body.appendChild(linkNode);
              linkNode.click(); //模拟在按钮上的一次鼠标单击
              URL.revokeObjectURL(linkNode.href); // 释放URL 对象
              document.body.removeChild(linkNode);
              this.loading = false;
            });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    appendComment(item) {
      this.query(this.filters.pagination.page);
    },
    // 编辑
    handleEdit(index, row) {
      this.dialogForm = true;
      // 根据id查询详情
      let querys = {
        dermatologyRegisterId: row.dermatologyRegisterId
      }
      api.request("/register/findDermatologyRegisterById", querys, (res) => {
        console.log(res)
        this.childData = res.data;
        this.childData.registerInformationDtoList.forEach(ele => {
          if (ele.partDoctor) {
            ele.partDoctor = ele.partDoctor.split(',')
          }
          if (ele.dutyNurse) {
            ele.dutyNurse = ele.dutyNurse.split(',')
          }
        })
        this.childData.operationMaterials.forEach(ele => {
          ele.injectionProductList.forEach(item => {
            item.injectionPart = item.injectionPart.split(',')
          });
        })
      });
      this.$nextTick(() => {
        this.code = 1
        this.$refs.addSkin.openDialog1Visible();
        this.$refs.addSkin.openLoading();
      });
    },
    // 查看日志
    handleLog(index, row) {
      this.dialogTableVisible = true
      // 根据id查询当条日志
      let querys = {
        operateType: '注射微整科手术表',
        registerId: row.dermatologyRegisterId
      }
      api.request("/register/findRegisterLogById", querys, (res) => {
        console.log(res)
        this.gridData = res.data;
      });
    },
    del() {
      var data = this.multipleSelection;
      var id = [];
      data.map(function (item, index) {
        id.push(item.dermatologyRegisterId);
      });
      this.$confirm("确定要删除选中的数据吗？", "删除项目", {
        center: true,
      })
        .then((res) => {
          api.requestQuiet("/register/deleteDermatologyRegisterById", { surgeryRegisterId: id.toString(), createBy: this.userName, },
            (res) => {
              if (res.result == true) {
                _g.toast("success", "删除成功");
                this.query(this.filters.pagination.page);
              } else {
                _g.toast("error", "删除失败");
                this.query(this.filters.pagination.page);
              }
            }
          );
        })
        .catch((err) => {
          // this.$message.error('删除失败！');
        });
    },
    // 姓名多选款
    onBlur(val) {
      if (val == 'clientName') {
        if (this.inputclientName != '' && !this.filters.clientName.includes(this.inputclientName)) {
          this.filters.clientName.push(this.inputclientName)
          this.inputclientName = ''
        }
      } else if (val == 'clientMobile') {
        if (this.inputmobile != '' && !this.filters.clientMobile.includes(this.inputmobile)) {
          this.filters.clientMobile.push(this.inputmobile)
          this.inputmobile = ''
        }
      } else if (val == 'clientCard') {
        if (this.inputCard != '' && !this.filters.clientCard.includes(this.inputCard)) {
          this.filters.clientCard.push(this.inputCard)
          this.inputCard = ''
        }
      }
    },
    onInput(index, val) {
      if (index.target.value != '') {
        if (val == 'clientName') {
          this.inputclientName = index.target.value
        } else if (val == 'clientMobile') {
          this.inputmobile = index.target.value
        } else if (val == 'clientCard') {
          this.inputCard = index.target.value
        }
      }
    },
    doctorMatch(val) {
      this.newList1 = _g.paramMatch(this.skinDoctorList, this.newList1, val, 'menuName')
    },
    nurseMatch(val) {
      this.newList2 = _g.paramMatch(this.skinNurseList, this.newList2, val, 'menuName')
    },
    productionMatch(val) {
      this.newList3 = _g.paramMatch(this.skinList, this.newList3, val, 'menuName')
    },
    focus(val) {
      if (val == 1) {
        this.newList1 = this.skinDoctorList
      } else if (val == 2) {
        this.newList2 = this.skinNurseList
      } else if (val == 3) {
        this.newList3 = this.skinList
      }
    },
    change(index, row) {
      let data = {
        dermatologyRegisterId: row.dermatologyRegisterId,
        createdBy: this.empId,
        // 0：正常 1：禁用
      }
      api.request("/register/updateDermatologyRegisterExamine", data, (res) => {
        if (res.result == true) {
          _g.toast("success", "标记操作成功")
          this.query(this.filters.pagination.page)
        } else {
          _g.toast("error", "标记操作失败")
          this.query(this.filters.pagination.page)
        }
      })
    },
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 350
  },
  mounted() {
    /*this.init();*/
    this.$store.dispatch('getallList')
    this.query(this.filters.pagination.page);
  },
  watch: {
    $route(to, from) {
      if (this.activatedFlag) {
        this.query(this.filters.pagination.page);
      }
    },
  },
}
</script>
<style scoped>
@import "../../assets/css/main.css";
.pageInput >>> .el-input__inner {
  width: 400px;
  height: 38px;
  background: #f6f7fb;
  border-radius: 23px;
  border: none;
}

.pageInput >>> .el-button {
  height: 34px;
  border-radius: 17px;
  border: 1px solid #979797;
  line-height: 5px;
  margin-left: 8px;
}
.el-table >>> .warningRed {
  color: #f56c6c;
}
.no >>> .el-select-dropdown {
  display: none;
}
</style>